import {createStyles, Theme, withStyles} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";


const styles = createStyles((theme:Theme)=>({
  checked: {
    color: `${theme.colors.primary} !important`
  }
}));

const RadioButton = withStyles(styles)(Radio);
export default RadioButton;

